import Vue from "vue";
import Vuex, { StoreOptions } from "vuex";
import RootState from "./RootState";
import AlarmModule from "./modules/alarm.module";
import MobModule from "./modules/mob.module";
import EnrollModule from "./modules/enroll.module";
import ProfileModule from "./modules/profile.module";
import SensorModule from "./modules/sensor.module";
import AppModule from "./modules/app.module";

Vue.use(Vuex);

const rootStore: StoreOptions<RootState> = {
    state: {
        version: "1.0.0", // a simple property
    },
    mutations: {},
    actions: {},
    getters: {},
    modules: {},
};

const store = new Vuex.Store<RootState>(rootStore);
export const alarm = new AlarmModule({ store, name: "alarm" });
export const app = new AppModule({ store, name: "app" });
export const profile = new ProfileModule({ store, name: "profile" });
export const sensor = new SensorModule({ store, name: "sensor" });
export const enrollState = new EnrollModule({ store, name: "enroll" });
export const mobState = new MobModule({ store, name: "mob" });
export default store;
